import { useSelector } from "react-redux";
import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { ImagePreview } from "../FormElements";

export const GraphicEditor = ({ cue, media, onUpdate, encode = true }) => {
	const cloud = useSelector((state) => state.rundown.cloud) || false;

	return (
		<>
			{/* <H2RSelect
				selected={cue.backgroundFit || "cover"}
				label="Image size"
				options={[
					{
						label: "Grow to fill screen",
						value: "cover",
					},
					{
						label: "Shrink to fit",
						value: "contain",
					},
				]}
				onChange={(value) => {
					return onUpdate({ backgroundFit: value });
				}}
			/> */}

			<H2RInput
				label="Name"
				value={cue.name}
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>
			
            <H2RInput
				label="Pause at frame"
                type="number"
				min="1"
				max="10000"
				step={1}
				value={cue.stopAt || ''}
				onChange={(value) => {
					onUpdate({ stopAt: value });
				}}
			/>

			{cloud ? (
				<H2RInput
					label="Image URL"
					value={cue.url}
					placeholder={`https://media.h2r.graphics/image.png`}
					onChange={(change) => {
						onUpdate({ url: change });
					}}
				/>
			) : (
				<H2RSelect
					selected={cue.filename}
					label="Image sequence"
					options={
						media.length === 0
							? [
									{
										label: "Add images in the Media tab",
										value: ``,
										disabled: true,
									},
							  ]
							: [
									...media
										.filter((item) => item.mimetype.includes("png"))
                    .filter((item) => {
											console.log(item.partOf, item.originalname, item.firstFile)
											return (item.partOf && !(item.originalname !== item.firstFile))
										})
										.sort((a, b) => {
											if(a.originalname.toUpperCase() < b.originalname.toUpperCase()) { return -1; }
											if(a.originalname.toUpperCase() > b.originalname.toUpperCase()) { return 1; }
											return 0;
										})
										.map((item) => {
											return {
												label: `[Sequence] ${item.originalname}`,
												value: item.partOf,
											};
										}),
							  ]
					}
					onChange={(value) => {
						return onUpdate({ filename: value });
					}}
				/>
			)}
			<ImagePreview image={cue.filename} />
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.name || "Image"}</span>
		</div>
	);
};
